// What a list needs to know about an issue the moment somebody finishes it.
//
// A resolved / abandoned issue is finished work: every live list hides it.
// The server already does that at fetch time (?hideResolved / ?hideAbandoned),
// but a row the user has JUST finished sat there saying "Resolved" until the
// page was reloaded. These actions carry that one fact across the app so the
// row leaves the list in the same frame as the click.
export const ISSUE_FINISHED = "ISSUE_FINISHED";           // one id took a terminal status
export const ISSUES_FINISHED = "ISSUES_FINISHED";         // several at once (bulk actions)
export const ISSUE_REOPENED = "ISSUE_REOPENED";           // back into play - show it again
export const ISSUES_LIST_REFRESH = "ISSUES_LIST_REFRESH"; // the refresh button: refetch, keep the page
export const ISSUES_FORGET_FINISHED = "ISSUES_FORGET_FINISHED"; // drop the local memory
// A ROW WAS DECIDED, THE SERVER CONFIRMED, AND THE LIST SHOULD SAY SO.
//
// One event for every kind of row a review surface holds - a proposal, a
// claim, a revision, an import item, a schedule update, a checklist
// completion, an issue. The store records {label, at} against the row's
// id; the list redraws with the outcome badged on the row, then drops it
// once its beat has passed. Dispatched ONLY after the server answered, so
// a settled row is never a guess.
export const ROW_SETTLED = "ROW_SETTLED";                 // { scope, id, label }
export const ROWS_SETTLED = "ROWS_SETTLED";               // { scope, ids, label }
export const ROW_UNSETTLED = "ROW_UNSETTLED";             // it came back open: forget it
export const ROWS_SETTLE_SWEEP = "ROWS_SETTLE_SWEEP";     // drop records whose beat is over
